export default import.meta.ROLLDOWN_FILE_URL_l2DCUs52Uq2oIOe0iK6upA